import { Shield, HandHeart, HeartPulse, Mountain, PackageOpen, Home, Users2, Stethoscope, Car, Calculator, Briefcase } from "lucide-react";

// Catalogo prodotti del Portale Partner. La chiave è il `code` salvato in
// partner.enabled_products (RBAC). `to` = rotta interna; `external` = link esterno.
export const PRODUCT_CATALOG = {
  rc_economia_solidale: { label: "RC Economia Solidale", to: "/quota/nuovo", icon: Shield, line: "cat", who: "ETS, cooperative, associazioni", g: ["RCT/RCO", "Volontari", "Tutela legale"] },
  infortuni_economia_solidale: { label: "Infortuni Economia Solidale", to: "/quota/infortuni", icon: HeartPulse, line: "cat", who: "Soci, volontari, lavoratori", g: ["Morte", "Invalidità", "Diaria"] },
  multirischi_beni: { label: "Danni ai Beni", to: "/quota/multirischi", icon: PackageOpen, line: "cat", who: "Sedi e beni dell'ente", g: ["Incendio", "Furto", "Elettronica"] },
  mrv_volontariato: { label: "Multirischi del Volontariato", to: "/quota/mrv", icon: HandHeart, line: "cat", who: "Organizzazioni di volontariato", g: ["Infortuni", "Malattia", "RC"] },
  cat_nat_impresa: { label: "Cat Nat", to: "/quota/catnat", icon: Mountain, line: "cat", who: "Imprese (obbligo di legge)", g: ["Terremoto", "Alluvione", "Frana"] },
  formula_service: { label: "Formula Service", sub: "Eticapro Infortuni Assimoco", to: "/formula-service", icon: Calculator, line: "persona", who: "Persone seguite dal Partner", g: ["Infortuni", "Assistenza"] },
  protezione_famiglia: { label: "Formula Self", sub: "Protezione Famiglia", to: "/formula-self", icon: Users2, line: "persona", who: "Persone e famiglie in autonomia", g: ["Infortuni H24", "Vantaggi fiscali"] },
  casa_multirischi: { label: "Casa", to: "/quota/casa", icon: Home, line: "persona", who: "Abitazione e famiglia", g: ["Fabbricato", "Contenuto", "RC famiglia"] },
  auto: { label: "Auto (RCA)", external: "https://assietica.it/basta-la-targa", icon: Car, line: "persona", who: "Privati e famiglie", g: ["Basta la Targa"] },
  cooperazione_salute: { label: "Cooperazione Salute 4You", sub: "Piani sanitari 4You", to: "/quota/cooperazione-salute", icon: Stethoscope, line: "salute", who: "Persone e famiglie", g: ["Salute", "Sostegno", "Famiglia"] },
  d_o: { label: "D&O", sub: "Directors & Officers", to: "/quota/do", icon: Briefcase, line: "cat", who: "Amministratori e consiglieri", g: ["RC amministratori", "Tutela legale"] },
};

// Prodotti annunciati, non ancora preventivabili (visibili a tutti come "In arrivo")
export const COMING_SOON = [];

export const PRODUCT_LINES = [
  { key: "cat", title: "Cooperazione, Associazionismo e Terzo Settore", short: "CAT · Terzo Settore", group: "Soluzioni Eticapro", color: "#5E9732" },
  { key: "persona", title: "Linea Persona", short: "Linea Persona", group: "Persone e famiglie", color: "#F39200" },
  { key: "salute", title: "Cooperazione Salute", short: "Cooperazione Salute", group: "Piani sanitari 4You", color: "#E53935" },
];

// Ordine di visualizzazione
export const PRODUCT_ORDER = [
  "rc_economia_solidale", "infortuni_economia_solidale", "multirischi_beni", "mrv_volontariato",
  "cat_nat_impresa", "d_o", "formula_service", "protezione_famiglia", "casa_multirischi", "auto", "cooperazione_salute",
];

// Prodotti visibili al Partner, raggruppati per linea (i non abilitati sono nascosti)
export function catalogFor(user) {
  const items = PRODUCT_ORDER.filter((c) => !PRODUCT_CATALOG[c].soon && isProductEnabled(user, c))
    .map((code) => ({ code, ...PRODUCT_CATALOG[code] }));
  return PRODUCT_LINES.map((l) => ({ ...l, items: [...items, ...COMING_SOON].filter((i) => i.line === l.key) })).filter((l) => l.items.length);
}

// Mappa rotta interna → codice prodotto (per il guard di accesso URL)
export const ROUTE_TO_PRODUCT = {
  "/quota/cooperazione-salute": "cooperazione_salute",
  "/quota/do": "d_o",
  "/quota/nuovo": "rc_economia_solidale",
  "/quota/mrv": "mrv_volontariato",
  "/quota/infortuni": "infortuni_economia_solidale",
  "/quota/catnat": "cat_nat_impresa",
  "/quota/multirischi": "multirischi_beni",
  "/quota/casa": "casa_multirischi",
  "/formula-service": "formula_service",
  "/formula-self": "protezione_famiglia",
};

export const ALL_PRODUCT_CODES = Object.keys(PRODUCT_CATALOG);

// true se l'utente (partner) è abilitato al prodotto. Admin/agenzia → sempre true.
export function isProductEnabled(user, code) {
  if (!user) return false;
  if (["agency_admin", "agency_operator", "agency_catnat"].includes(user.role)) return true;
  const enabled = user?.partner?.enabled_products;
  if (!Array.isArray(enabled)) return !["cooperazione_salute", "d_o"].includes(code); // retrocompatibilità; prodotti su abilitazione esplicita
  return enabled.includes(code);
}
